export enum ACTION_TYPES {
  CLEAR_CONVEYANCING_DATA = 'CLEAR_CONVEYANCING_DATA',
  CLEAR_CONVEYANCING_ERROR = 'CLEAR_CONVEYANCING_ERROR',
  FETCH_CONVEYANCING = 'FETCH_CONVEYANCING',
  FETCH_CONVEYANCING_SUCCESS = 'FETCH_CONVEYANCING_SUCCESS',
  FETCH_CONVEYANCING_FAIL = 'FETCH_CONVEYANCING_FAIL',
  FETCH_CONVEYANCING_INTENT = 'FETCH_CONVEYANCING_INTENT',
  FETCH_CONVEYANCING_INTENT_SUCCESS = 'FETCH_CONVEYANCING_INTENT_SUCCESS',
  FETCH_CONVEYANCING_INTENT_FAIL = 'FETCH_CONVEYANCING_INTENT_FAIL',
  CREATE_CONVEYANCING_PROPERTY_ID = 'CREATE_CONVEYANCING_PROPERTY_ID',
  CREATE_CONVEYANCING_INTENT = 'CREATE_CONVEYANCING_INTENT',
  CREATE_CONVEYANCING_INTENT_SUCCESS = 'CREATE_CONVEYANCING_INTENT_SUCCESS',
  CREATE_CONVEYANCING_INTENT_FAIL = 'CREATE_CONVEYANCING_INTENT_FAIL',
}
